import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { OutboundLink } from 'src/components/OutboundLink'
import { cn } from 'src/utils/cx'
import { useAgentMioUrl } from 'src/utils/hooks/useAgentMioUrl'
import { DISPLAYABLE_AGENTS } from './agentMetadata'

type Props = {
  internalCaller: string | undefined
} & StyleProps

const ArtworkDetailCreationAssistant: FC<Props> = ({
  internalCaller,
  className,
  style,
}) => {
  const { t } = useTranslation(['artwork', 'common'])
  const agentMioUrl = useAgentMioUrl({ utmContent: 'artwork_detail' })

  if (!internalCaller) return null

  const agent = DISPLAYABLE_AGENTS[internalCaller]
  if (!agent) return null

  return (
    <div className="mt-3 flex flex-col gap-1">
      <h3 className="font-medium">{t('artwork:creation-assistant.title')}</h3>
      <OutboundLink
        href={agentMioUrl}
        className={cn(
          'flex items-center gap-2 p-1 -m-1 text-left rounded-xl no-underline',
          'hover:bg-black/10',
          'dark:hover:bg-white/10',
          className,
        )}
        style={style}
      >
        <div className="flex-none grid size-16 overflow-hidden bg-zinc-300 dark:bg-zinc-600 rounded-lg ring-1 ring-black/10 dark:ring-white/10">
          <img
            src={agent.avatarUrl}
            alt={t(agent.nameKey)}
            className="row-start-1 col-start-1 object-cover object-top w-full h-full"
          />
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="flex gap-1 items-center">
            <span className="rounded w-fit h-auto px-1.5 py-0 mr-0 bg-violet-400 text-black text-xs font-medium">
              {t('artwork:creation-assistant.agent-badge')}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex-1 w-full truncate text-sm font-medium">
              {t(agent.nameKey)}
            </span>
          </div>
          <p className="text-xs truncate">{t(agent.descriptionKey)}</p>
        </div>
      </OutboundLink>
    </div>
  )
}

export default ArtworkDetailCreationAssistant
